import { render, staticRenderFns } from "./PublicitarioForm.vue?vue&type=template&id=2fa348ae"
import script from "./PublicitarioForm.vue?vue&type=script&lang=js"
export * from "./PublicitarioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports